export default "__VITE_ASSET__DlPhRU9Y__"